import { MessageCircle, ShieldCheck, Smartphone, AlertTriangle, Loader2 } from 'lucide-react'

import { isEmbeddedSignupConfigured } from '../../../services/meta/embedded-signup'

function Beneficio({ icon: Icon, titulo, texto }) {
  return (
    <div className="flex gap-3">
      <Icon className="w-5 h-5 mt-0.5 shrink-0 text-orange-600" />
      <div>
        <p className="font-medium text-gray-800">{titulo}</p>
        <p className="text-sm text-gray-600">{texto}</p>
      </div>
    </div>
  )
}

export function Connect({ status, error, onConnect }) {
  const conectando = status === 'connecting'
  const configurado = isEmbeddedSignupConfigured()

  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="rounded-lg border border-gray-200 bg-white p-6 flex flex-col gap-5">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            Conecte o WhatsApp da sua loja
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            As confirmações de agendamento passam a sair do número da sua
            unidade, pelo WhatsApp oficial da Meta.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-3">
          <Beneficio
            icon={MessageCircle}
            titulo="Seu número"
            texto="O cliente vê o nome e o número da sua loja, e responde pra você."
          />
          <Beneficio
            icon={Smartphone}
            titulo="Você continua atendendo"
            texto="O WhatsApp no celular segue funcionando normalmente, no mesmo número."
          />
          <Beneficio
            icon={ShieldCheck}
            titulo="Canal oficial"
            texto="Sem aplicativo paralelo e sem risco de bloqueio do número."
          />
        </div>

        <div className="rounded-md bg-gray-50 border border-gray-200 p-4">
          <p className="text-sm font-medium text-gray-800 mb-2">
            Antes de começar, tenha em mãos:
          </p>
          <ul className="text-sm text-gray-600 list-disc pl-5 space-y-1">
            <li>O celular com o WhatsApp Business da loja, atualizado</li>
            <li>Acesso à conta Meta (Facebook) do seu negócio</li>
            <li>Um cartão para cadastrar na Meta — a cobrança é feita por ela</li>
          </ul>
        </div>

        {!configurado && (
          <div className="flex gap-2 items-start rounded-md bg-amber-50 border border-amber-200 p-3">
            <AlertTriangle className="w-4 h-4 mt-0.5 text-amber-600 shrink-0" />
            <p className="text-sm text-amber-800">
              Integração ainda não configurada neste ambiente. Fale com o suporte
              Petland.
            </p>
          </div>
        )}

        {error && (
          <div className="flex gap-2 items-start rounded-md bg-red-50 border border-red-200 p-3">
            <AlertTriangle className="w-4 h-4 mt-0.5 text-red-600 shrink-0" />
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        <div>
          <button
            type="button"
            onClick={onConnect}
            disabled={conectando || !configurado}
            className="inline-flex items-center gap-2 rounded-md bg-orange-600 px-5 py-2.5 text-white font-medium hover:bg-orange-700 disabled:opacity-60 disabled:cursor-not-allowed transition"
          >
            {conectando && <Loader2 className="w-4 h-4 animate-spin" />}
            {conectando ? 'Aguardando a Meta...' : 'Conectar meu WhatsApp'}
          </button>
          <p className="text-xs text-gray-500 mt-2">
            Leva cerca de 5 minutos e é uma vez só.
          </p>
        </div>
      </div>
    </div>
  )
}
